import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {CourseModule} from "../../models/course-module";
import {UserStateProvider} from "../user-state/user-state";
import {UserStateDto, UserProgress, UserStats, UserFinishedVideo} from "./user-state-dto";
import {UserProgressStateProvider} from "../user-progress-state/user-progress-state";
import {UserStatsProvider} from "../user-stats/user-stats";
import {UserTagProvider} from "../user-tag/user-tag";
import {CourseVideo} from "../../models/course-video";
import {Events} from "ionic-angular";
import {ChallengeProvider} from "../challenge/challenge";

/*
  Generated class for the ApiCourseDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiCourseDataProvider {

  constructor(
    public api: ApiProvider,
    public userData: UserStateProvider,
    public progressData: UserProgressStateProvider,
    public statsProvider: UserStatsProvider,
    public tagProvider: UserTagProvider,
    public events: Events,
    public challenge: ChallengeProvider,
  ) {
    this.events.subscribe('state:refresh', () => {
      this.resetData();
      this.getCourseData().then();
    })
  }

  private courseData: Array<CourseModule>;
  private additionalVideos: Array<CourseVideo>
  getCourseData() {
    var me = this;
    return new Promise<Array<CourseModule>>((resolve, reject) => {
      if(me.courseData) {
        return resolve(me.courseData);
      }

      me.api.callGet<UserStateDto>('/users/'+this.userData.user.id+'/state').subscribe((res:UserStateDto) => {
        console.log('user state dto loaded', res);
        res.courseModules.sort((a,b) => {
          return (a.position > b.position)?1:-1;
        });

        res.currentProgress = new UserProgress(res.currentProgress);

        let finishedVideos = [];
        res.finishedVideos.map((finished: UserFinishedVideo) => {
          finishedVideos.push(finished.id);
        })

        res.courseModules.map(module => {
          module._userStatus = 3;
          module._userClosed = 0;

          if(module.type != 'normal') {
            module._userStatus = 2;
          }

          module.videos.sort((a,b) => {
            return (a.position > b.position)?1:-1;
          });
          module.videos.map(a => {
            if(finishedVideos.indexOf(a.id) > -1) {
              module._userClosed++;
              a._userStatus = 3;
              res.finishedVideos.map((finished: UserFinishedVideo) => {
                if (finished.id == a.id) {
                  a._userDate = finished.date.substr(0,10);
                }
              })
            } else{
              a._userStatus = 1;
            }
            if(res.currentProgress.videoId == a.id && res.currentProgress.status < 2) {
              module._userStatus = 2;
              a._userStatus = 2;
              a._userDate = res.currentProgress.date.substr(0,10);
              res.currentProgress.video = a;
            }
            if(module._userStatus == 3 && finishedVideos.indexOf(a.id) == -1) {
              module._userStatus = 1;
              a._userStatus = 3;
            }

            a.module = module;
          });

          me.progressData.currentProgress = res.currentProgress;
          me.progressData.recentStats = res.recentStats;
          me.tagProvider.loadTags(res.tags);
        });

        res.recentStats.map(stat => {
          var statObj = new UserStats(stat);
          me.statsProvider.addStats(statObj);
        });

        me.statsProvider.getUserStats(res.currentProgress.date).then(stats => {
          res.currentProgress.stats = stats;
          res.currentProgress.triggerVideoStatusUpdate();
          stats.progress = res.currentProgress;
        })

        me.challenge.setInAppData(res.challengesInApp);
        me.challenge.setUserChallenges(res.challengesUser);

        me.courseData = res.courseModules;
        me.additionalVideos = res.additionalVideos;

        console.log(me);

        me.events.publish('state:refreshed', me);

        if(me.additionalVideos.filter(v => {
          return v.bonusVideo && v._userStatus !==2;
        }).length == 0) {
          me.events.publish('video:bonusWatched');
        }

        for(var k in me.courseData) {
          if (me.courseData[k]._userStatus == 3) {
            me.events.publish('module:finished', {position: me.courseData[k].position});
          }
        }

        return resolve(me.courseData);
      }, err => reject(err));

    });

  }

  getAddtionalVideos() {
    return this.additionalVideos;
  }

  getMyWayCourses() {
    return this.getCourseData().then(modules => {
      var result = [];
      modules.map(module => {
        module.videos.map(video => {
          if(video.type == 'my-way') {
            result.push(video);
          }
        })
      });

      return result;
    })
  }

  resetData() {
    this.additionalVideos = null;
    this.courseData = null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-course-data/api-course-data.ts